// extracted by mini-css-extract-plugin
module.exports = {"pintxo-avatar":"Avatar_pintxo-avatar__w99YK","pintxo-avatar__shape":"Avatar_pintxo-avatar__shape__p6tB_","pintxo-avatar__shape__text":"Avatar_pintxo-avatar__shape__text__s5tC4"};